package twist.mena.sports.admin.theme

import org.jetbrains.compose.web.css.px

object Spacing {
    val xs = 4.px
    val sm = 8.px
    val md = 12.px
    val lg = 16.px
    val xl = 20.px
    val xxl = 24.px
}

object Typography {
    val xs = 11.px
    val sm = 12.px
    val base = 14.px
    val lg = 16.px
    val xl = 18.px
    val xxl = 24.px
}

object BorderRadius {
    val sm = 4.px
    val md = 6.px
    val lg = 8.px
    val xl = 10.px
    val pill = 30.px
    const val circle = "50%"
}

object Shadow {
    const val sm = "0 1px 3px rgba(0,0,0,0.1), 0 1px 2px -1px rgba(0,0,0,0.1)"
    const val md = "0 5px 15px rgba(40,60,80,0.15)"
    const val lg = "0 10px 25px rgba(40,60,80,0.15)"
    const val dark = "0 0 20px rgba(0,0,0,0.5)"
}
